/**
 * De horizontale indeling van het banen-diagram.
 *
 * Apart van de component omdat 't de enige rekenkundige stap in de weergave is
 * en dus toetsbaar hoort te zijn — met name het geval dat het model een lus
 * bevat. Dat mag van de taal, en het mag de weergave niet laten hangen.
 */
/**
 * Kolom per stap: hoe ver van het begin van de stroom.
 *
 * Sharp tekent van links naar rechts, dus de horizontale plek is de diepte in
 * de stroomgraaf. Een stap zonder inkomende stroom begint links. De teller
 * begrenst het geval waarin het model een cyclus bevat — dat mag, en het mag
 * de weergave niet laten hangen.
 */
export function kolommen(
  stapIds: readonly string[],
  stromen: Array<[string, string]>,
): Map<string, number> {
  const inkomend = new Map<string, string[]>();
  for (const id of stapIds) inkomend.set(id, []);
  for (const [van, naar] of stromen) {
    if (inkomend.has(naar) && inkomend.has(van)) inkomend.get(naar)?.push(van);
  }
  const kolom = new Map<string, number>();
  const bezig = new Set<string>();
  const diepte = (id: string): number => {
    const bekend = kolom.get(id);
    if (bekend !== undefined) return bekend;
    if (bezig.has(id)) return 0;
    bezig.add(id);
    const bronnen = inkomend.get(id) ?? [];
    const d = bronnen.length === 0 ? 0 : Math.max(...bronnen.map((b) => diepte(b) + 1));
    bezig.delete(id);
    kolom.set(id, d);
    return d;
  };
  for (const id of stapIds) diepte(id);
  return kolom;
}
